import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { RedditKarma, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import MetadataIconsContainer from './MetadataIconsContainer'

type KarmaIconProps = {
  message: string
}

const KarmaIcon = ({ message }: KarmaIconProps) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  const color = sys[theme].text.placeholder
  const tooltip = `${t('redditKarma')}: ${message}`

  return (
    <Tooltip mode={theme} enabled content={tooltip}>
      <div>
        <MetadataIconsContainer message={message}>
          <RedditKarma color={color} />
        </MetadataIconsContainer>
      </div>
    </Tooltip>
  )
}

export default KarmaIcon
